<template>
    <div class="notification_bar">
        <div 
            ref="noticeOut" 
            :class="['notification_out',]" 
            :style="{animation: `noticeOut${MIXIN_LANG=='EG'?'EG':''} ${aDuration}ms linear infinite`}"
        >
            <div :class="['notice_inner']" ref="noticeInner" :style="{animation: `noticeInner${MIXIN_LANG=='EG'?'EG':''} ${aDuration}ms linear infinite`}">
                {{ notice }}
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";

interface Props {
    notice: string,
}

const props = withDefaults(defineProps<Props>(), {
    notice: '',
})

const noticeOut = ref<HTMLDivElement|null>(null);
const noticeInner = ref<HTMLDivElement|null>(null);

const aDuration = computed(() => {
    if (!noticeOut.value?.getBoundingClientRect || !noticeInner.value?.getBoundingClientRect) return 0;
    
    const outWidth = noticeOut.value.getBoundingClientRect().width;
    const innerWidth = noticeInner.value.getBoundingClientRect().width;
    
    // 能全部显示不需要滚动
    if (outWidth >= innerWidth) return 0;

    // 这里动态设置动画时间，如果文案名称太长了，就增加滚动时间
    return innerWidth/outWidth * 5000;
})

</script>

<style scoped lang="scss">
@use '@page/202411/PreludeRank/scss/public_mixin.scss' as *;

.notification_bar {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .notification_out {
        position: relative;
        min-width: 100%;
        height: 30px;
        left: 0;
        top: 0;
    
        .notice_inner {
            position: absolute;
            min-width: 100%;
            white-space: nowrap;
            font-size: 26px;
            line-height: 30px;
            transform: translate3d(0%, 0, 0);
            opacity: 1;
        }
    }
}

</style>
<style lang="scss">
@keyframes noticeOut {
    from {
        left: 100%;
    }

    1% {
        left: 100%;
    }

    99.8% {
        left: 0%;
    }

    99.9% {
        left: 0%;
    }

    to {
        left: 100%;
    }
}

@keyframes noticeInner {
    from {
        transform: translate3d(0%, 0, 0);
        opacity: 0;
    }

    1% {
        transform: translate3d(0%, 0, 0);
        opacity: 1;
    }

    99.8% {
        transform: translate3d(-100%, 0, 0);
        opacity: 1;
    }

    99.9% {
        transform: translate3d(-100%, 0, 0);
        opacity: 0;
    }

    to {
        transform: translate3d(0%, 0, 0);
        opacity: 0;
    }
}
@keyframes noticeOutEG {
    from {
        left: -100%;
    }

    1% {
        left: -100%;
    }

    99.8% {
        left: 0%;
    }

    99.9% {
        left: 0%;
    }

    to {
        left: -100%;
    }
}

@keyframes noticeInnerEG {
    from {
        transform: translate3d(0%, 0, 0);
        opacity: 0;
    }

    1% {
        transform: translate3d(0%, 0, 0);
        opacity: 1;
    }

    99.8% {
        transform: translate3d(100%, 0, 0);
        opacity: 1;
    }

    99.9% {
        transform: translate3d(100%, 0, 0);
        opacity: 0;
    }

    to {
        transform: translate3d(0%, 0, 0);
        opacity: 0;
    }
}

</style>
